import { useTranslation } from "react-i18next";

const KEYS = [
  "intro", "service", "eligibility", "content", "risk", "form", "liability", "links", "changes", "law", "contact",
];

export default function Terms() {
  const { t } = useTranslation();
  return (
    <article className="legal-page" data-testid="terms-page">
      <div className="legal-inner">
        <span className="eyebrow">{t("nav.legal")}</span>
        <h1 className="h-display legal-title">{t("terms.title")}</h1>
        <p className="legal-updated">{t("terms.updated")}</p>
        {KEYS.map((k) => (
          <section className="legal-section" key={k}>
            <h2 className="legal-h2">{t(`terms.${k}Title`)}</h2>
            <p className="legal-body">{t(`terms.${k}Text`)}</p>
          </section>
        ))}
      </div>
    </article>
  );
}
